export const convertHotelSlugToHotelId = (hotelSlug: string): string => {
  if (!hotelSlug) return ''

  const parts = hotelSlug.split('-')
  return parts[parts.length - 1]
}
